import React from "react";
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export default function RadioGroup({ label, value, onChange, data }) {

  const handleChange = (selectedValue) => {
    if (value === selectedValue) {
      onChange("");
    } else {
      onChange(selectedValue);
    }
  };

  if (!data) return null;
  return (
    <>
      <Typography variant="body2" gutterBottom sx={{ mb: 1 }}>
        {label}
      </Typography>
      <Grid container direction="row" spacing={1} sx={{ mb: 2 }}>
        {data.map((item, key) => {
          return (
            <Grid key={key}>
              <Chip
                sx={{ width: 120 }}
                variant={value === item.value ? "default" : "outlined"}
                color="primary"
                label={item.label.toUpperCase()}
                onClick={() => handleChange(item.value)}
                // size="small"
                icon={ item.color ? <FiberManualRecordIcon fontSize="large" style={{ color: item.color }} /> : null}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
